var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',{staticClass:"text-lg-center text-md-center text-sm-center earth-color"},[_vm._v("Terms and Conditions")]),_c('v-card',[_c('v-container',[_c('v-container',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.singlePage.description)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }